import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { EButtonType } from "../../data-types/button.enum";
import { EInputStyleType } from "../../data-types/input-style.enum";
import { ETextareaStyleType } from "../../data-types/textarea-style.enum";
import { Validators } from "@angular/forms";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { EInputMediaStyleType } from "../../data-types/input-media-style.enum";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { LocalStorageService } from "../../services/local-storage.service";
import { EStorageType } from "../../data-types/storage.enum";
import { CompanyService } from "../../services/company.service";
import { Store } from "@ngrx/store";
import { IAppState } from "../../store/state/app.state";
import { showAlertAction } from "../../store/actions/alert.action";
import { TranslateService } from "@ngx-translate/core";
import { Company } from "../../data-types/company.interface";
@Component({
  selector: "cowing-core-company-info",
  templateUrl: "./company-info.component.html",
  styleUrls: ["./company-info.component.scss"],
})
export class CompanyInfoComponent implements OnInit, OnDestroy {
  @Input("form") form: FormGroup;
  @Output("location") location = new EventEmitter();
  public EInputStyleType = EInputStyleType;
  public EInputMediaStyleType = EInputMediaStyleType;
  public EButtonType = EButtonType;
  public ETextareaStyleType = ETextareaStyleType;
  public endGetInfo = false;
  public companyId;
  public isCreateCompanyFromPanel: boolean;
  constructor(
    private router: Router,
    private companyService: CompanyService,
    private _store: Store<IAppState>,
    private translate: TranslateService
  ) {}
  async ngOnInit() {
    this.companyId = LocalStorageService.instance.get(
      EStorageType.ActiveCompany
    );
    this.isCreateCompanyFromPanel = this.companyId && !this.isEditingInfo;
    // EDIT compamny
    if (this.companyId && this.isEditingInfo) {
      try {
        this._store.dispatch(showLoadingAction({}));
        const response = await this.companyService.getCompanyInfo(
          this.companyId
        );
        console.log("response:", response);
        if (response.business_group) {
          this.form.get("is_business_group").disable();
          // this.form.get("is_business_group").;
          this.form.get("business_group").setValue(response.business_group);
          this.form.get("business_group").disable();
        }

        this.form.patchValue({
          is_business_group: response.business_group ? "SÃ­" : "No",
        });
        this.form.get("email").disable();
        if (response.image) {
          this.form.patchValue({
            file: response.image,
          });
        } else {
          this.form.patchValue({
            file: "qwert",
          });
        }
        this.form.patchValue(response);
        // this.setHours(response);
        // this.setMedia(response);

        // this.form.markAllAsTouched();
      } catch (e) {
        this._store.dispatch(
          showAlertAction({
            payload: {
              message:
                e.status === 401
                  ? this.translate.instant("general.expired")
                  : e.data.error,
              title: this.translate.instant("general.caution"),
              type: "error",
            },
          })
        );
      } finally {
        this.endGetInfo = true;
        this._store.dispatch(closeLoadingAction({}));
      }
      // CREATING NEW ONE FROM USERPANEL
    } else if (this.companyId && !this.isEditingInfo) {
      this._store.dispatch(showLoadingAction({}));
      const response = await this.companyService.getCompanyInfo(this.companyId);
      this.form.get("email").setValue(response.email);
      if (!response.business_group) {
        this.form.patchValue({
          is_business_group: "SÃ­",
        });
        this.form.get("is_business_group").disable();
        this.form.get("business_group").enable();
        this.form.get("business_group").setValidators(Validators.required);
      } else {
        this.form.patchValue({
          is_business_group: "SÃ­",
        });
        this.form.get("business_group").setValue(response.business_group);
        this.form.get("is_business_group").disable();
        this.form.get("business_group").disable();
      }
      this.endGetInfo = true;
      this._store.dispatch(closeLoadingAction({}));
      // CREATING NEW FROM REGISTRATION FUNNEL
    } else {
      this.endGetInfo = true;
    }

    this.form.get("is_business_group").valueChanges.subscribe((value) => {
      if (
        (this.endGetInfo && !this.companyId) ||
        (this.endGetInfo && this.companyId && this.isEditingInfo)
      ) {
        const businessGroupName = this.form.get("business_group");
        if (value === "No" && businessGroupName.disabled === false) {
          businessGroupName.setValidators([]);
          businessGroupName.disable();
          businessGroupName.setValue("");
        } else if (value === "SÃ­" && businessGroupName.disabled === true) {
          businessGroupName.setValidators([Validators.required]);
          businessGroupName.enable();
        }

        businessGroupName.updateValueAndValidity();
      }
    });
  }

  public get isEditingInfo() {
    return this.router.url === "/company-info" ? true : false;
  }
  public setLocation(currentLocation) {
    !this.isEditingInfo
      ? this.location.emit(currentLocation)
      : this._setLocation(currentLocation);
  }
  public _setLocation(location) {
    this.form.get("latitude").setValue(location.lat);
    this.form.get("longitude").setValue(location.lng);
    this.form.get("city").setValue(location.city);
    this.form.get("country").setValue(location.country);
    this.form.get("province").setValue(location.province);
  }
  public goBack() {
    this.router.navigate(["company-home"]);
  }
  public get isDisabledForm() {
    return this.form.dirty && this.form.valid ? false : true;
  }

  private formGeneralInfoData() {
    const form = this.form.getRawValue();
    const formattedForm = new Company(form);
    return formattedForm;
  }

  private formMedia() {
    let mediaFormData: FormData = new FormData();

    mediaFormData.append("file", this.form.get("file").value);
    return mediaFormData;
  }

  public async editCompany() {
    const companyId = LocalStorageService.instance.get(
      EStorageType.ActiveCompany
    );
    this._store.dispatch(showLoadingAction({}));
    try {
      await this.companyService.putCompanyInfo(
        companyId,
        this.formGeneralInfoData()
      );
      if (typeof this.form.get("file").value != "string") {
        await this.companyService.putMediaToCompany(
          this.formMedia(),
          companyId
        );
      }
      this._store.dispatch(
        showAlertAction({
          payload: {
            message: "",
            title: this.translate.instant("company.general.success_put"),
            type: "alert",
          },
        })
      );
      this.goBack();
    } catch (e) {
      this._store.dispatch(
        showAlertAction({
          payload: {
            message:
              e.status === 401
                ? this.translate.instant("general.expired")
                : e.data.error,
            title: this.translate.instant("general.caution"),
            type: "error",
          },
        })
      );
    } finally {
      this._store.dispatch(closeLoadingAction({}));
    }
  }
  ngOnDestroy() {
    // this.form.get("is_business_group").valueChanges.
  }
}
